import type { FieldMetadata } from "@conform-to/react";
import cx from "clsx";
import type { ReactNode } from "react";

export function Fieldset({
  label,
  field,
  className,
  children,
}: {
  label?: string;
  field?: FieldMetadata;
  className?: string;
  children: ReactNode;
}) {
  return (
    <fieldset className={cx("fieldset flex-1", className)}>
      {label !== undefined ? (
        <label className="fieldset-label" htmlFor={field?.id}>
          {label}
          {field?.required === true ? " *" : ""}
        </label>
      ) : undefined}

      {children}

      {field?.errors ? (
        <p className="fieldset-label text-error">{field.errors}</p>
      ) : undefined}
    </fieldset>
  );
}
